export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    id: "f1",
    q: "嘿咻嘿咻漫画讲了一个什么样的故事？",
    a: "它讲述深夜电台编辑阿浩与青梅竹马小雨、导师老周以及吉祥物嘿咻猫咪之间平凡又温暖的日常。主线围绕「十年之约」展开，用一段段看似琐碎的片段，串起关于陪伴、告别与成长的主题。",
  },
  {
    id: "f2",
    q: "漫画的结局是圆满还是遗憾？",
    a: "这是读者讨论最多的话题。从表面看，结局留下了一句「没说出口的再见」，略带遗憾；但结合全剧伏笔来看，作者更想表达的是「学会好好告别」的圆满。关于「遗憾还是圆满」的完整拆解，可以在剧情解析页的结局专题里读到。",
  },
  {
    id: "f3",
    q: "入坑前需要了解哪些背景？",
    a: "不需要。故事采用平易近人的日常叙事，前几话就会把主要人物和世界观交代清楚。对于新人，建议先阅读剧情速览栏目里的开篇导读，再按顺序追更，体验会更顺。",
  },
  {
    id: "f4",
    q: "嘿咻猫咪为什么是「灵魂角色」？",
    a: "嘿咻从不开口，却总在剧情的关键节点出现，像一位无声的观察者。它既是阿浩情绪的「锚点」，也承载了大量治愈与隐藏设定，是许多读者二刷时会特别注意的线索角色。",
  },
  {
    id: "f5",
    q: "是否适合作为轻松向的睡前读物？",
    a: "非常适合。整体节奏舒缓、笑点自然、情绪克制而不煽情，单话篇幅适中，很适合在睡前安静地读上一两话，心情会变得很松弛。",
  },
  {
    id: "f6",
    q: "结局之后还会有番外或续作吗？",
    a: "截至目前，作者尚未官宣正式续作，但已透露会通过番外篇补齐部分配角的支线。读者可以留意本站在创作手记栏目中的跟进解读，有消息会第一时间整理更新。",
  },
];